import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const product = {
  name: "Rolex Datejust 41",
  skus: [
    {
      key: "Reference Number",
      value: "126334",
    },
    {
      key: "Movement",
      value: "Automatic",
    },
    {
      key: "Case Material",
      value: "Steel",
    },
    {
      key: "Dial Color",
      value: "Blue",
    },
    {
      key: "Case Diameter",
      value: "41 mm",
    },
  ],
  image_url:
    "https://cdn2.chrono24.com/images/products/25600-25799/25731_s500_Blue.jpg",
  similar_product_link: "",
};

const ListingPreview = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const data = location?.state;

  return (
    <section className="max-w-[1200px]  mx-auto lg:px-2 md:px-4 sm:px-4 lg:py-16 md:py-14 sm:py-12 mb-20">
      <div className="lg:w-7/12 md:w-9/12 sm:w-11/12 mx-auto">
        <h2 className="lg:text-3xl md:text-2xl sm:text-xl mb-6">
          Sell This Watch
        </h2>

        <div className="flex lg:flex-row md:flex-row sm:flex-col gap-6 mt-8">
          <img
            src={data?.imageUrl}
            alt=""
            height={300}
            width={300}
            className="border rounded-lg "
          />
          <div className=" w-full flex flex-col justify-between">
            <h2 className="text-2xl ">{data?.title}</h2>

            <div className="my-8">
              <div className="flex justify-between gap-4 text-[14px]">
                <p className="">
                  Reference Number
                  {" :"}
                </p>
                <p className="font-medium">{data.refId}</p>
              </div>
              <div className="flex justify-between gap-4 text-[14px]">
                <p className="">
                  Movement
                  {" :"}
                </p>
                <p className="font-medium">{data.movement}</p>
              </div>
              <div className="flex justify-between gap-4 text-[14px]">
                <p className="">
                  Case Material
                  {" :"}
                </p>
                <p className="font-medium">{data.caseMaterial}</p>
              </div>
              <div className="flex justify-between gap-4 text-[14px]">
                <p className="">
                  Dial Color
                  {" :"}
                </p>
                <p className="font-medium">{data.dialColor}</p>
              </div>
              <div className="flex justify-between gap-4 text-[14px]">
                <p className="">
                  Case diameter
                  {" :"}
                </p>
                <p className="font-medium">{data.caseDiameter} mm</p>
              </div>
            </div>

            <Link to={"/user/create-listing"} className="text-[14px] underline">
              Choose a different model
            </Link>
          </div>
        </div>

        <div className="p-4 rounded-lg bg-primary mt-8 text-[14px]">
          {" "}
          <p>
            The most important features will automatically be filled in when you
            enter the model. All you have to do is add a few details, some
            photos, and a description – and your listing is ready to go.
          </p>{" "}
        </div>
      </div>

      {/* CTA */}
      <nav className="mt-24 border-t">
        <div className="flex justify-between items-center w-full my-6">
          <div />
          <button
            onClick={() => {
              navigate(`/listing/create-listing?stepNo=1`, { state: data });
            }}
            className="px-12 py-2.5 rounded bg-secondary text-white text-sm"
          >
            Get started
          </button>
        </div>
      </nav>
    </section>
  );
};

export default ListingPreview;
